<template>
  <span style="color: red; font-weight: 500"
    ><template v-if="depositCount == 1"
      >The seller has to confirm equipment availability before you pay the full
      amount.</template
    >
    <template v-else>
      You are buying equipments from multiple sellers. <br />
      Each sellers has to confirm equipment availability before you pay the full
      amount.
    </template>
  </span>
  <br /><br />
  <span style="font-weight: 500"
    >In order to confirm your intention to buy, we do request a card deposit of
    USD 200 <template v-if="depositCount > 1">per equipment</template></span
  >
  <br /><br />
  <div class="note-payment">
    <div
      class="note-payment-title"
      style="font-weight: 500; border-bottom: solid 1px black; width: 100px"
    >
      Please note
    </div>
    <br />
    <div class="note-1">
      <svg
        width="20"
        style="width: 50px"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 3V7H17.66C17.9499 6.99672 18.2371 7.0565 18.5016 7.17522C18.7661 7.29393 19.0016 7.46873 19.1919 7.68751C19.3821 7.90629 19.5225 8.16382 19.6033 8.44225C19.6842 8.72068 19.7035 9.01336 19.66 9.3L18.28 18.3C18.2077 18.7769 17.9654 19.2116 17.5979 19.524C17.2304 19.8364 16.7623 20.0055 16.28 20H6L6 6.75L9 0C9.79565 0 10.5587 0.316071 11.1213 0.87868C11.6839 1.44129 12 2.20435 12 3ZM4 20L4 9H2C1.46957 9 0.960859 9.21071 0.585786 9.58579C0.210714 9.96086 0 10.4696 0 11V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H4Z"
          fill="#52C41A"
        />
      </svg>
      <span class="up-text"
        >This payment in fully refunded in case the product you are trying to
        buy is not available anymore.</span
      >
    </div>
    <br />
    <div class="note2">
      <svg
        width="20"
        style="width: 50px"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.999 0.000361495H3.71905C3.23673 -0.00509124 2.76868 0.163956 2.40115 0.476355C2.03362 0.788754 1.79138 1.22346 1.71905 1.70036L0.339054 10.7004C0.295546 10.987 0.31488 11.2797 0.395714 11.5581C0.476549 11.8365 0.616952 12.0941 0.807195 12.3128C0.997439 12.5316 1.23297 12.7064 1.49748 12.8251C1.76199 12.9439 2.04915 13.0036 2.33905 13.0004H7.99905V17.0004C7.99905 17.796 8.31512 18.5591 8.87773 19.1217C9.44034 19.6843 10.2034 20.0004 10.9991 20.0004L13.999 13.2504V0.000366211C13.999 0.000364639 13.999 0.000363067 13.999 0.000361495ZM15.999 11.0004H17.6691C18.235 11.0104 18.785 10.8122 19.2145 10.4435C19.644 10.0749 19.9232 9.5613 19.9991 9.00036V2.00036C19.9232 1.43942 19.644 0.925863 19.2145 0.55718C18.785 0.188497 18.235 -0.00964765 17.6691 0.000361495H15.999C15.999 0.000363067 15.999 0.000364639 15.999 0.000366211V11.0004Z"
          fill="#FB4E4E"
        />
      </svg>
      <span class="down-text">
        You will lose the deposit in case you don’t pay the remaining balance
        after product availability is confirmed.
      </span>
    </div>
  </div>

  <br />
  <card
    :buttonMessage="'Pay deposit now'"
    :paymentDoneAction="paymentDoneAction"
    :total="depositAmount"
    :currency="depositCurrency"
  ></card>
  <br />
</template>

<script>
import Card from "./Card.vue";
import { reactive } from "@vue/reactivity";

export default {
  components: { Card },
  setup() {
    const step = reactive({
      value: 1,
    });

    const changeStep = (value) => {
      store.commit("paymentMethodSelected", value);
      step.value = value;
    };

    return {
      step,
      changeStep,
    };
  },
  props: {
    depositCount: Number,
    showRefundMessage: {
      default: false,
    },
    depositAmount: Number,
    depositCurrency: Object,
    paymentDoneAction: Function,
  },
};
</script>

<style>
</style>